import React from 'react';
import classnames from 'classnames';
export const DataListHeaderRow = (props) => {
    const classes = classnames('DataList__HeaderRow', props.className);
    return React.createElement("div", { className: classes }, props.children);
};
//# sourceMappingURL=DataListHeaderRow.js.map